import React from 'react';

import { Body } from '../../../typography';

import Stack from '../../../stack';
import RadioGroup from '../../../radio-group';

import { exercisePropTypes } from '../../../../constants/exercise';

import { ANSWER_LABELS, FINAL_ANSWER_RESULTS, getCheckboxHighlight } from '../../../../lib/checker';

const FinalAnswer = ({ exercise, finalAnswer, correction, onReplace }) => {
    const getCheckboxOptions = (checkboxType) => {
        return {
            id: checkboxType,
            text: ANSWER_LABELS[checkboxType],
            disabled: !!correction,
            checked: finalAnswer === checkboxType,
            highlight: getCheckboxHighlight(checkboxType, correction, exercise.answerType, finalAnswer),
        };
    };

    return (
        <Stack gap="small">
            <Body weight="semi-bold">{'Hai finito?'}</Body>

            <RadioGroup
                exerciseId={exercise.id}
                gap="small"
                name="answers"
                onClick={(value) => onReplace(value)}
                options={[FINAL_ANSWER_RESULTS.STEP, FINAL_ANSWER_RESULTS.INDETERMINATE, FINAL_ANSWER_RESULTS.IMPOSSIBLE].map(
                    getCheckboxOptions,
                )}
            />
        </Stack>
    );
};

FinalAnswer.propTypes = exercisePropTypes;

export default FinalAnswer;
